import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthLayout, AuthStepProgress, RegisterFormEmail } from '../components';
import Homescreen_icon from '../../home/assets/Homescreen.png';
import { AUTH_FORM_CARD_CLASS, AUTH_TITLE_CLASS } from '../lib/authStyles';

export function RegisterPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('access_token');

    // If the user already has a token, they should probably be on the company registration or dashboard
    // GuestLayout already redirects them, but just in case:
    if (token) {
      navigate('/company-registration', { replace: true });
    }
  }, [navigate]);

  const [activeTab] = useState('email'); // 'email' or 'phone'

  const handleStepOneSuccess = () => {
    navigate('/company-registration');
  };

  return (
    <AuthLayout rightImage={Homescreen_icon} rightAlt="Aexon Assistant Mockup">
      <div className="animate-fadeIn">
        <AuthStepProgress
          currentStep={1}
          totalSteps={2}
          stepTitle="User Registration"
        />

        <h1 className={AUTH_TITLE_CLASS}>Create Your Account</h1>

        <div className="mt-4">
          <div className={`${AUTH_FORM_CARD_CLASS} text-left`}>
            <div className="relative grid grid-cols-1 w-full border-b border-border-default mb-6">
              {/* temporarily: single email tab; restore min-[380px]:grid-cols-2 + phone tab below */}
              <button
                type="button"
                // onClick={() => handleTabChange('email')}
                className={`w-full min-h-[52px] px-2 py-3 text-center text-h6-medium sm:text-body-lg-medium leading-tight font-sf-pro-display relative transition-colors ${
                  activeTab === 'email'
                    ? 'text-primary'
                    : 'text-text-primary hover:text-primary'
                }`}
              >
                Register With Email
                {activeTab === 'email' && (
                  <div className="absolute bottom-0 left-0 right-0 z-10 h-[2px] bg-primary animate-fadeIn" />
                )}
              </button>
              {/* temporarily disabled: register with mobile
                  <button
                    type="button"
                    onClick={() => handleTabChange('phone')}
                    className={`w-full min-h-[52px] px-2 py-3 text-center text-h6-medium sm:text-body-lg-medium leading-tight font-sf-pro-display relative transition-colors ${
                      activeTab === 'phone'
                        ? 'text-primary'
                        : 'text-text-primary hover:text-primary'
                    }`}
                  >
                    Register With Phone
                    {activeTab === 'phone' && (
                      <div className="absolute bottom-0 left-0 right-0 z-10 h-[2px] bg-primary animate-fadeIn" />
                    )}
                  </button>
                  */}
            </div>

            <RegisterFormEmail onSuccess={handleStepOneSuccess} />
            {/* temporarily disabled: register with mobile
                {activeTab === 'email' ? (
                  <RegisterFormEmail onSuccess={handleStepOneSuccess} />
                ) : (
                  <RegisterFormMobile
                    onSuccess={handleStepOneSuccess}
                    otpSent={otpSent}
                    setOtpSent={setOtpSent}
                  />
                )}
                */}

            <div className="text-center mt-4">
              <p className="text-body-lg font-normal font-sf-pro-display text-text-primary">
                Already have an account?{' '}
                <Link
                  to="/login"
                  onClick={() => localStorage.clear()}
                  className="text-primary text-body-lg underline transition-colors"
                >
                  Login
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}
